import { components } from 'react-select'
import PropTypes from 'prop-types'

import Icon from '../../../Icons'

const MenuCustomOption = (props) => {
  const { isSelected, data } = props

  return (
    <components.Option {...props}>
      <div className="tags-menu">
        <div className="tags-menu__value">{data.label}</div>
        {isSelected ? (
          <div className="tags-menu__value-icon">
            <Icon icon={'checkmark'} viewBox="0 0 30 30" />
          </div>
        ) : null}
      </div>
    </components.Option>
  )
}

MenuCustomOption.propTypes = {
  data: PropTypes.string,
  isSelected: PropTypes.bool,
}

export default MenuCustomOption
